import DOMPurify from 'dompurify';
import { wordWrapStJude } from './app-utils';

export const sanitizeHtml = (text: string): JSX.Element => {
  // St Jude needs to be treated as a single word
  const wordWrapped = wordWrapStJude(text || '');
  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(wordWrapped) }}
    />
  );
};
